<main class="marketplace-detail">
  <nav
    class="detail-navigation"
    [attr.aria-label]="t.getMarketplaceBrowseText()"
  >
    @if (parentProduct) {
      <a
        class="back"
        [routerLink]="['/marketplace', parentProduct.id]"
        fragment="components-heading"
      >
        <mat-icon aria-hidden="true">arrow_back</mat-icon
        >{{ t.getMarketplaceBackToProductText(parentProduct.name) }}
      </a>
    } @else {
      <a routerLink="/marketplace" class="back"
        ><mat-icon aria-hidden="true">arrow_back</mat-icon
        >{{ t.getMarketplaceBackText() }}</a
      >
    }
  </nav>
  @if (loading) {
    <div class="detail-state" role="status">
      <mat-spinner diameter="36"></mat-spinner
      >{{ t.getMarketplaceLoadingText() }}
    </div>
  } @else if (failed) {
    <div class="detail-state" role="alert" id="detail-error" tabindex="-1">
      {{
        notFound
          ? t.getMarketplaceNotFoundText()
          : t.getMarketplaceLoadFailedText()
      }}
      @if (!notFound) {
        <button mat-stroked-button type="button" (click)="load()">
          {{ t.getMarketplaceRetryText() }}
        </button>
      }
    </div>
  } @else if (product) {
    <div class="detail-layout" [class.no-picture]="!product.picture">
      <header class="detail-heading">
        @if (product.brand) {
          <span class="brand">{{ product.brand }}</span>
        }
        <h1 id="product-heading" tabindex="-1">{{ product.name }}</h1>
        <p class="seller">
          {{ t.getMarketplaceSupplierText() }}: {{ product.seller }}
        </p>
        @if (product.isOwnProduct) {
          <span class="own-listing">{{
            t.getMarketplaceOwnListingText()
          }}</span>
        }
      </header>
      <div class="detail-image">
        <app-product-image
          [picture]="product.picture"
          [name]="product.name"
          [compact]="!product.picture"
          loading="eager"
        />
      </div>
      <section
        class="purchase-panel"
        [attr.aria-label]="t.getMarketplaceDetailsText()"
      >
        @if (summary()) {
          <p class="product-summary">{{ summary() }}</p>
        }
        <div class="price-line">
          <strong>{{ price() }}</strong>
          <span
            >{{
              product.priceAmount !== null
                ? '/'
                : t.getMarketplaceRequestUnitText() + ':'
            }}
            {{
              t.getMarketplaceRequestUnitValueText(product.requestUnit)
            }}</span
          >
        </div>
        <ng-container
          [ngTemplateOutlet]="requestControls"
          [ngTemplateOutletContext]="{ $implicit: product }"
        />
        @if (components.length) {
          <a
            class="component-jump"
            [attr.href]="'/marketplace/' + product.id + '#components-heading'"
            (click)="showComponents($event)"
          >
            <mat-icon aria-hidden="true">grid_view</mat-icon
            >{{ t.getMarketplaceViewComponentsText(components.length)
            }}<mat-icon aria-hidden="true">arrow_downward</mat-icon>
          </a>
        }
      </section>
    </div>
    @if (componentsLoading || componentsFailed || components.length) {
      <section class="components-section" aria-labelledby="components-heading">
        <div class="section-heading">
          <h2 id="components-heading" tabindex="-1">
            {{ t.getMarketplaceComponentsText() }}
            @if (components.length) {
              <span class="component-count">{{ components.length }}</span>
            }
          </h2>
          @if (components.length > 1) {
            <div class="carousel-controls">
              <button
                mat-icon-button
                type="button"
                [attr.aria-label]="t.getMarketplacePreviousComponentsText()"
                aria-controls="component-rail"
                [disabled]="railAtStart"
                (click)="scrollComponents(-1)"
              >
                <mat-icon>chevron_left</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                [attr.aria-label]="t.getMarketplaceNextComponentsText()"
                aria-controls="component-rail"
                [disabled]="railAtEnd"
                (click)="scrollComponents(1)"
              >
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }
        </div>
        <p class="section-help">{{ t.getMarketplaceComponentsHelpText() }}</p>
        @if (componentsLoading) {
          <div class="component-state" role="status">
            <mat-spinner diameter="28"></mat-spinner
            >{{ t.getMarketplaceLoadingText() }}
          </div>
        } @else if (componentsFailed) {
          <div class="component-state" role="alert">
            <p>{{ t.getMarketplaceComponentsLoadFailedText() }}</p>
            <button mat-stroked-button type="button" (click)="loadComponents()">
              {{ t.getMarketplaceRetryText() }}
            </button>
          </div>
        } @else {
          <div
            class="component-grid"
            id="component-rail"
            role="group"
            [attr.aria-label]="t.getMarketplaceComponentsText()"
            tabindex="0"
            (scroll)="updateRailState()"
            (keydown.arrowright)="scrollComponents(1, $event)"
            (keydown.arrowleft)="scrollComponents(-1, $event)"
          >
            @for (component of components; track component.id) {
              <article class="component-card">
                <a
                  class="component-image"
                  [routerLink]="['/marketplace', component.id]"
                  [state]="componentNavigation()"
                  tabindex="-1"
                  aria-hidden="true"
                >
                  <app-product-image
                    [picture]="component.picture"
                    [name]="component.name"
                  />
                </a>
                <div class="component-info">
                  <h3>
                    <a
                      [routerLink]="['/marketplace', component.id]"
                      [state]="componentNavigation()"
                      >{{ component.name }}</a
                    >
                  </h3>
                  <p class="seller">
                    {{ t.getMarketplaceSupplierText() }}: {{ component.seller }}
                  </p>
                  <div class="price-line">
                    <strong>{{ price(component) }}</strong
                    ><span
                      >{{
                        component.priceAmount !== null
                          ? '/'
                          : t.getMarketplaceRequestUnitText() + ':'
                      }}
                      {{
                        t.getMarketplaceRequestUnitValueText(
                          component.requestUnit
                        )
                      }}</span
                    >
                  </div>
                  <div class="component-request">
                    <ng-container
                      [ngTemplateOutlet]="requestControls"
                      [ngTemplateOutletContext]="{ $implicit: component }"
                    />
                  </div>
                </div>
              </article>
            }
          </div>
        }
      </section>
    }
    <div class="product-sections">
      <div class="product-story">
        @if (product.description) {
          <section class="information-section">
            <h2>{{ t.getMarketplaceDescriptionText() }}</h2>
            <p class="description">{{ product.description }}</p>
          </section>
        }
        <app-product-custom-fields
          [fields]="product.customFields"
          [heading]="t.getMarketplaceOtherInformationText()"
        />
      </div>
      @if (hasSpecifications()) {
        <section class="information-section specifications">
          <h2>{{ t.getMarketplaceSpecificationsText() }}</h2>
          <dl>
            @if (product.marketplaceCategory) {
              <dt>{{ t.getMarketplaceCategoryLabelText() }}</dt>
              <dd>
                {{ t.getMarketplaceCategoryText(product.marketplaceCategory) }}
              </dd>
            }
            @if (product.marketplaceSubcategory) {
              <dt>{{ t.getMarketplaceSubcategoryLabelText() }}</dt>
              <dd>
                {{
                  t.getMarketplaceSubcategoryText(
                    product.marketplaceSubcategory
                  )
                }}
              </dd>
            }
            @if (product.condition) {
              <dt>{{ t.getMarketplaceConditionText() }}</dt>
              <dd>
                {{ t.getMarketplaceConditionValueText(product.condition) }}
              </dd>
            }
            @if (product.measureValue !== null) {
              <dt>{{ t.getMarketplaceWeightRangeText() }}</dt>
              <dd>{{ product.measureValue }} {{ product.measureUnit }}</dd>
            }
            @if (product.droneFlightTimeMinutes !== null) {
              <dt>{{ t.getMarketplaceFlightTimeText() }}</dt>
              <dd>
                {{ product.droneFlightTimeMinutes }}
                {{ t.getMarketplaceMinutesText() }}
              </dd>
            }
            @if (product.droneType) {
              <dt>{{ t.getMarketplaceDroneTypeText() }}</dt>
              <dd>{{ product.droneType }}</dd>
            }
            @if (product.droneVideoResolution) {
              <dt>{{ t.getMarketplaceVideoResolutionText() }}</dt>
              <dd>{{ product.droneVideoResolution }}</dd>
            }
            @if (product.droneSensorSize) {
              <dt>{{ t.getMarketplaceSensorSizeText() }}</dt>
              <dd>{{ product.droneSensorSize }}</dd>
            }
            @if (product.droneFpv !== null) {
              <dt>{{ t.getMarketplaceFpvText() }}</dt>
              <dd>{{ product.droneFpv ? t.getYesText() : t.getNoText() }}</dd>
            }
          </dl>
        </section>
      }
    </div>
    <div class="cart-status" aria-live="polite">
      @if (marketplace.cartError() && !cartActionId) {
        <p role="alert">
          {{ t.getRequisitionCartErrorText(marketplace.cartError()) }}
        </p>
      }
      @if (marketplace.cartLoadFailed()) {
        <p role="alert">{{ t.getRequisitionCartLoadFailedText() }}</p>
        <button mat-button type="button" (click)="marketplace.loadCart(true)">
          {{ t.getMarketplaceRetryText() }}
        </button>
      }
      @if (marketplace.cartCount()) {
        <p class="selection-note" role="status">
          {{ t.getMarketplaceSelectionCountText(marketplace.cartCount()) }}.
          <a routerLink="/requisition-cart">{{ t.getRequisitionCartText() }}</a>
        </p>
      }
    </div>
  }
</main>

<ng-template #requestControls let-item>
  @if (item.allowRequests && marketplace.canUseCart()) {
    @if (saving(item.id)) {
      <div class="saving-state" role="status">
        <mat-spinner diameter="20"></mat-spinner
        >{{ t.getMarketplaceSavingText() }}
      </div>
    } @else if (marketplace.isSelected(item.id)) {
      <p class="added-state" role="status">
        <mat-icon aria-hidden="true">check_circle</mat-icon
        >{{
          t.getMarketplaceAddedQuantityText(
            cartQuantity(item.id),
            t.getMarketplaceRequestUnitValueText(item.requestUnit)
          )
        }}
      </p>
      <div class="selected-actions">
        <a
          mat-flat-button
          class="primary-action"
          routerLink="/requisition-cart"
          >{{ t.getMarketplaceViewCartText() }}</a
        >
        <button
          mat-button
          type="button"
          (click)="select(item)"
          [attr.aria-label]="
            t.getMarketplaceRemoveSelectionText() + ': ' + item.name
          "
          [disabled]="
            marketplace.pendingId() !== null || marketplace.cartLoading()
          "
        >
          {{ t.getRemoveText() }}
        </button>
      </div>
    } @else {
      <div class="add-quantity">
        <label [for]="'request-quantity-' + item.id">{{
          t.getQuantityText()
        }}</label>
        <div class="quantity-field">
          <input
            [id]="'request-quantity-' + item.id"
            type="number"
            [attr.aria-label]="t.getQuantityText() + ': ' + item.name"
            [attr.inputmode]="
              marketplace.wholeUnit(item.requestUnit) ? 'numeric' : 'decimal'
            "
            [attr.min]="marketplace.wholeUnit(item.requestUnit) ? '1' : '0'"
            [attr.step]="marketplace.wholeUnit(item.requestUnit) ? '1' : 'any'"
            [value]="quantityDrafts[item.id] ?? '1'"
            [disabled]="
              marketplace.pendingId() !== null || marketplace.cartLoading()
            "
            [attr.aria-invalid]="invalidQuantityId === item.id ? 'true' : null"
            [attr.aria-describedby]="
              invalidQuantityId === item.id ? 'quantity-error-' + item.id : null
            "
            (input)="quantityChanged(item.id, $event)"
          />
          <span>{{
            t.getMarketplaceRequestUnitValueText(item.requestUnit)
          }}</span>
        </div>
        @if (invalidQuantityId === item.id) {
          <p
            class="quantity-error"
            role="alert"
            [id]="'quantity-error-' + item.id"
          >
            {{
              marketplace.wholeUnit(item.requestUnit)
                ? t.getRequisitionCartWholeQuantityText()
                : t.getRequisitionCartPositiveQuantityText()
            }}
          </p>
        }
      </div>
      <button
        mat-flat-button
        class="primary-action"
        type="button"
        (click)="select(item)"
        [attr.aria-label]="t.getMarketplaceSelectText() + ': ' + item.name"
        [disabled]="
          marketplace.pendingId() !== null || marketplace.cartLoading()
        "
      >
        {{ t.getMarketplaceSelectText() }}
      </button>
    }
  } @else {
    <p class="unavailable">
      <mat-icon aria-hidden="true">info_outline</mat-icon
      ><span>{{
        item.isOwnProduct
          ? t.getMarketplaceOwnRequestUnavailableText()
          : !item.allowRequests
            ? t.getMarketplaceRequestsUnavailableText()
            : t.getMarketplaceRequestRoleRequiredText()
      }}</span>
    </p>
  }
  @if (cartActionId === item.id && marketplace.cartError()) {
    <div class="request-error" role="alert">
      <p>{{ t.getRequisitionCartErrorText(marketplace.cartError()) }}</p>
      @if (marketplace.cartError() === 'save') {
        <button mat-stroked-button type="button" (click)="select(item)">
          {{ t.getMarketplaceRetryText() }}
        </button>
      }
    </div>
  }
</ng-template>
